import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { DatePicker } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CREATE_jwel } from "../Config/Config";
import Header from "../Header";
import SidebarDrawer from "../SidebarDrawer";
import styles from "./TopTen.module.css";

const sections = [
  "Top 10 Invoices",
  "Top 10 Brands",
  "Top 10 Prices",
  "Top 10 Sales Man",
  "Top 10 Products",
];

const TopTen = () => {
  const [expanded, setExpanded] = useState(null);
  const [open, setOpen] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [topTenInvoices, setTopTenInvoices] = useState([]);
  const [topTenBrands, setTopTenBrands] = useState([]);
  const [topTenPrices, setTopTenPrices] = useState([]);
  const [topTenSales, setTopTenSales] = useState([]);
  const [topTenProducts, setTopTenProducts] = useState([]);
  // const [imagesData, setImagesData] = useState([]);
  // const [userArea, setUserArea] = useState();
  // const [userName, setUserName] = useState();
  // const [singleImage, setSingleImage] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);

  const imageUrls = localStorage.getItem("images").split(",");
  const imagesData = imageUrls;
  const userArea = localStorage.getItem("city");
  const userName = localStorage.getItem("user");
  const singleImage = localStorage.getItem("singleImage");
  const tenantName = localStorage.getItem("tenantName");

  const toggleDrawer = () => {
    setOpen(false);
  };

  const TopTenInvoiceAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetTopTenBills?billStartDate=${dayjs(
          fromDate
        ).format("MM/DD/YYYY")}&billEndDate=${dayjs(toDate).format(
          "MM/DD/YYYY"
        )}`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      let data = response.data;

      const topTen = data.sort((a, b) => b.AMOUNT - a.AMOUNT).slice(0, 10);

      setTopTenInvoices(topTen);
    } catch (error) {
      console.error("Error fetching top ten invoices:", error);
    }
  };

  const TopTenBrandsAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetTopTenBrands?billStartDate=${dayjs(
          fromDate
        ).format("MM/DD/YYYY")}&billEndDate=${dayjs(toDate).format(
          "MM/DD/YYYY"
        )}`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;
      const topTen = data.sort((a, b) => b.AMOUNT - a.AMOUNT).slice(0, 10);
      setTopTenBrands(topTen);
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const TopTenPricesAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetTopTenPrice?billStartDate=${dayjs(
          fromDate
        ).format("MM/DD/YYYY")}&billEndDate=${dayjs(toDate).format(
          "MM/DD/YYYY"
        )}`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;
      const topTen = data.sort((a, b) => b.AMOUNT - a.AMOUNT).slice(0, 10);
      setTopTenPrices(topTen);
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const TopTenSalesAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetTopTenSalesMan?billStartDate=${dayjs(
          fromDate
        ).format("MM/DD/YYYY")}&billEndDate=${dayjs(toDate).format(
          "MM/DD/YYYY"
        )}`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;
      const topTen = data.sort((a, b) => b.AMOUNT - a.AMOUNT).slice(0, 10);
      setTopTenSales(topTen);
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const TopTenProductsAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetTopTenProducts?billStartDate=${dayjs(
          fromDate
        ).format("MM/DD/YYYY")}&billEndDate=${dayjs(toDate).format(
          "MM/DD/YYYY"
        )}&pType=%`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;
      const topTen = data.sort((a, b) => b.AMOUNT - a.AMOUNT).slice(0, 10);
      setTopTenProducts(topTen);
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  // const userAPI = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=FIRM_CONFIGURE`,
  //       {
  //         headers: {
  //           tenantName: tenantName,
  //         },
  //       }
  //     );

  //     const data = response.data;

  //     if (Array.isArray(data) && data.length > 0) {
  //       const imageUrls = data[0]?.EPASS1.split(",");
  //       setImagesData(imageUrls);
  //       setUserName(data[0]?.FIRMNAME);
  //       setUserArea(data[0]?.CITY);
  //       setSingleImage(data[0]?.EPASS2);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching estimation count:", error);
  //   }
  // };

  useEffect(() => {
    TopTenInvoiceAPI();
    TopTenBrandsAPI();
    TopTenPricesAPI();
    TopTenSalesAPI();
    TopTenProductsAPI();
    // userAPI();
  }, [fromDate, toDate]);

  // const handleExpandAll = () => {
  //   setExpanded(sections);
  // };

  // const handleCollapseAll = () => {
  //   setExpanded([]);
  // };

  const handleExpandAll = () => {
    setExpanded("all");
    TopTenInvoiceAPI();
    TopTenBrandsAPI();
    TopTenPricesAPI();
    TopTenSalesAPI();
    TopTenProductsAPI();
  };

  const handleCollapseAll = () => {
    setExpanded(null);
  };

  const handleChange = (panel) => {
    setExpanded((prev) => (prev === panel ? null : panel));
  };

  useEffect(() => {
    if (imagesData.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % imagesData.length);
      }, 1500);
      return () => clearInterval(interval);
    }
  }, [imagesData]);

  return (
    <div>
      <Header setOpen={setOpen} />
      <SidebarDrawer
        open={open}
        toggleDrawer={toggleDrawer}
        singleImage={singleImage}
        userArea={userArea}
        userName={userName}
      />
      <div className={styles.carouselContainer}>
        <div
          className={styles.carouselSlider}
          style={{
            transform: `translateX(-${currentIndex * 33.33}%)`,
            width: `${imagesData.length * 100}%`,
          }}
        >
          {imagesData.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`img-${index}`}
              className={styles.carouselImage}
            />
          ))}
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <h3 className={styles.heading}>Top 10</h3>
          <div className={styles.buttonRow}>
            <button
              variant="outlined"
              type="default"
              className={styles.expandButton}
              onClick={handleExpandAll}
            >
              Expand All +
            </button>
            <button
              variant="outlined"
              type="default"
              className={styles.collapseButton}
              onClick={handleCollapseAll}
            >
              Collapse All -
            </button>
          </div>
        </div>

        {/* Date Filters */}
        <div className={styles.dateFilters}>
          <DatePicker
            value={fromDate}
            onChange={setFromDate}
            className={styles.datePicker}
            inputReadOnly
            format="DD-MMM-YYYY"
            maxDate={dayjs()}
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
          />
          <DatePicker
            value={toDate}
            onChange={setToDate}
            className={styles.datePicker1}
            inputReadOnly
            format="DD-MMM-YYYY"
            maxDate={dayjs()}
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
          />
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel1" || expanded === "all"}
            onChange={() => {
              handleChange("panel1");
              TopTenInvoiceAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor:
                  expanded === "panel1" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel1" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Top 10 Invoices
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel1" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel1" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              {topTenInvoices.map((invoice, index) => (
                <div
                  key={invoice.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Bill No:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {invoice.billno}
                      </span>
                    </span>
                    <span
                      style={{
                        color: "#52bd91",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      #{index + 1}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      QTY:{" "}
                      <span
                        style={{
                          fontSize: "16px",
                          color: "#595a60",
                          fontWeight: "bold",
                        }}
                      >
                        {invoice.QTY}
                      </span>
                    </span>
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {invoice.AMOUNT.toFixed(2)}
                      </span>
                    </span>
                  </div>

                  <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                    {invoice.CustName}
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel2" || expanded === "all"}
            onChange={() => {
              handleChange("panel2");
              TopTenBrandsAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor:
                  expanded === "panel2" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel2" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Top 10 Brands
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel2" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel2" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              {topTenBrands.map((brand, index) => (
                <div
                  key={brand.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span
                      style={{
                        color: "#162566",
                        fontWeight: "bold",
                        fontSize: "14px",
                      }}
                    >
                      {brand.COMPNAME}
                    </span>
                    <span
                      style={{
                        color: "#52bd91",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      #{index + 1}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      QTY:{" "}
                      <span
                        style={{
                          fontSize: "16px",
                          color: "#595a60",
                          fontWeight: "bold",
                        }}
                      >
                        {brand.QTY}
                      </span>
                    </span>
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {brand.AMOUNT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel3" || expanded === "all"}
            onChange={() => {
              handleChange("panel3");
              TopTenPricesAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor:
                  expanded === "panel3" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel3" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Top 10 Prices
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel3" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel3" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              {topTenPrices.map((price, index) => (
                <div
                  key={price.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Act Rate:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {Number(price.ACTRATE).toFixed(2)}
                      </span>
                    </span>
                    <span
                      style={{
                        color: "#52bd91",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      #{index + 1}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      QTY:{" "}
                      <span
                        style={{
                          fontSize: "16px",
                          color: "#595a60",
                          fontWeight: "bold",
                        }}
                      >
                        {price.QTY}
                      </span>
                    </span>
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {price.AMOUNT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel4" || expanded === "all"}
            onChange={() => {
              handleChange("panel4");
              TopTenSalesAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor:
                  expanded === "panel4" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel4" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Top 10 Sales Man
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel4" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel4" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              {topTenSales.map((sales, index) => (
                <div
                  key={sales.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Code:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {sales.SMCODE}
                      </span>
                    </span>
                    <span
                      style={{
                        color: "#52bd91",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      #{index + 1}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      QTY:{" "}
                      <span
                        style={{
                          fontSize: "16px",
                          color: "#595a60",
                          fontWeight: "bold",
                        }}
                      >
                        {sales.QTY}
                      </span>
                    </span>
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {sales.AMOUNT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel5" || expanded === "all"}
            onChange={() => {
              handleChange("panel5");
              TopTenProductsAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor:
                  expanded === "panel5" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel5" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Top 10 Products
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel5" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel5" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              {topTenProducts.map((product, index) => (
                <div
                  key={product.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        {product.itemname}
                      </span>
                    </span>
                    <span
                      style={{
                        color: "#52bd91",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      #{index + 1}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      QTY:{" "}
                      <span
                        style={{
                          fontSize: "16px",
                          color: "#595a60",
                          fontWeight: "bold",
                        }}
                      >
                        {product.QTY}
                      </span>
                    </span>
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {product.AMOUNT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default TopTen;
